import { render, staticRenderFns } from "./ErrorSheet.vue?vue&type=template&id=6df040c6&scoped=true&"
import script from "./ErrorSheet.vue?vue&type=script&lang=js&"
export * from "./ErrorSheet.vue?vue&type=script&lang=js&"
import style0 from "./ErrorSheet.vue?vue&type=style&index=0&id=6df040c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df040c6",
  null
  
)

export default component.exports